// "Recent engagements" (verifier-workspace-ux W6, OI-9 browser-local): the ids of the engagements a
// person opened most recently, per user and firm, newest first. Ids only — every render re-checks
// them against the firm's live engagements, so nothing about access is cached (Invariant 4).
export const RECENT_LIMIT = 10;
export const RECENT_EVENT = 'cg:verifier-recent';

const keyOf = (userId, orgId) => `cg.verifier.recent.${userId}.${orgId}`;

export function readRecent(userId, orgId) {
  if (!userId || !orgId) return [];
  try {
    const parsed = JSON.parse(window.localStorage.getItem(keyOf(userId, orgId)) ?? '[]');
    return Array.isArray(parsed) ? parsed.filter((id) => typeof id === 'string') : [];
  } catch {
    return [];
  }
}

export function recordRecent(userId, orgId, engagementId) {
  if (!userId || !orgId || !engagementId) return;
  const next = [
    engagementId,
    ...readRecent(userId, orgId).filter((id) => id !== engagementId),
  ].slice(0, RECENT_LIMIT);
  try {
    window.localStorage.setItem(keyOf(userId, orgId), JSON.stringify(next));
    window.dispatchEvent(new Event(RECENT_EVENT));
  } catch {
    // Storage blocked (private window): the sidebar simply shows no Recent list.
  }
}
